var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 94,
    height: 96,
    viewBox: "0 0 94 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Elipse_15",
    x: 0,
    y: 0,
    width: 94,
    height: 96,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.341
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Componente_4_1",
    "data-name": "Componente 4 \\u2013 1",
    transform: "translate(78 79) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, 0, 0, -1, 78, 79)",
    filter: "url(#Elipse_15)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_15-2",
    "data-name": "Elipse 15",
    cx: 29,
    cy: 30,
    rx: 29,
    ry: 30,
    transform: "translate(76 78) rotate(180)",
    fill: "#e84671"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_35",
    "data-name": "Grupo 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_1",
    "data-name": "Elipse 1",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 31,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 29.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1057",
    "data-name": "Trazado 1057",
    d: "M7.713,16.66,0,8.675,6.78,0",
    transform: "translate(26.787 22.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNext);
export default __webpack_public_path__ + "static/media/icon-next.6823ef362981773dc52873e846ebd87c.svg";
export { ForwardRef as ReactComponent };